var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReply(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 6L9.95 6C9.95 5.69271 9.76255 5.4165 9.47697 5.30302C9.1914 5.18953 8.86549 5.26174 8.65457 5.48521L9.2 6ZM5 10.45L4.45457 9.93521C4.31674 10.0812 4.24323 10.2764 4.25049 10.4771C4.25775 10.6778 4.34518 10.8672 4.49321 11.0029L5 10.45ZM9.2 14.3L8.69321 14.8529C8.91245 15.0538 9.22975 15.1063 9.502 14.9865C9.77425 14.8667 9.95 14.5974 9.95 14.3L9.2 14.3ZM9.2 12.2L9.2 11.45L8.45 11.45L8.45 12.2L9.2 12.2ZM19.7481 18.4466C19.6905 17.64 19.5962 16.8362 19.4789 16.0559L17.9956 16.2788C18.108 17.0268 18.1975 17.7915 18.2519 18.5534L19.7481 18.4466ZM9.95 8.7L9.95 6L8.45 6L8.45 8.7L9.95 8.7ZM8.65457 5.48521L4.45457 9.93521L5.54543 10.9648L9.74543 6.51479L8.65457 5.48521ZM4.49321 11.0029L8.69321 14.8529L9.70679 13.7471L5.50679 9.89713L4.49321 11.0029ZM9.95 14.3L9.95 12.2L8.45 12.2L8.45 14.3L9.95 14.3ZM9.2 12.95L10.2547 12.95L10.2547 11.45L9.2 11.45L9.2 12.95ZM10.2547 12.95C14.0327 12.95 17.2626 15.1491 18.2789 18.706L19.7211 18.294C18.4997 14.0189 14.622 11.45 10.2547 11.45L10.2547 12.95ZM19.4789 16.0559C18.7253 11.0404 14.0992 7.95 9.2 7.95L9.2 9.45C13.536 9.45 17.3769 12.1616 17.9956 16.2788L19.4789 16.0559Z",
    fill: "#1E95F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.44922,
    y: 8.45117,
    width: 1,
    height: 1,
    fill: "#1E95F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.d5690a2e.svg";
export { ForwardRef as ReactComponent };